<template>
  <div class="toast-wrapper" ref="alert">
    <i></i>
    <p></p>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    toast(type='success', message, duraction=3000) {
      console.log('123')
    },
  }
}
</script>

<style scoped>
.toast-wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 165px;
  min-height: 115px;
  background:rgba(0,0,0,0.7);
  border-radius:10px;
  padding: 10px 0;
}
.toast-wrapper i {
  margin-bottom: 10px;
}
.toast-wrapper p {
  font-size:16px;
  /*font-family:MicrosoftYaHei;*/
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:30px;
  max-width: 105px;
}
</style>





// WEBPACK FOOTER //
// src/components/toast.vue